// Resolução do tenant (empresa) do chat público -- Task 8b (tenancy-foundation).
//
// O chat público identifica a empresa pelo slug público na URL
// (`chat.alodesk.com.br/<slug>`, ex.: `/farmaciax`). Esse valor é lido da
// rota (`/:slug`) e guardado aqui, num módulo simples, para que QUALQUER
// chamada à API -- venha de um componente React ou de uma action/thunk do
// redux, que não tem acesso a `props.match` -- consiga anexar o slug sem
// precisar prop-drill.
//
// Compatibilidade com produção: a URL de produção hoje é
// `https://chat-alodesk.sysfar.com.br/` (SEM slug). Sem um slug na rota,
// caímos no slug padrão configurável via REACT_APP_DEFAULT_TENANT_SLUG
// (default "sysfar" se a env não estiver definida), então a URL atual
// continua funcionando sem mudanças.
export const DEFAULT_TENANT_SLUG = process.env.REACT_APP_DEFAULT_TENANT_SLUG || 'sysfar';

let currentTenantSlug = DEFAULT_TENANT_SLUG;

// Chamado (de forma síncrona, no corpo do componente de rota, nunca em um
// useEffect) assim que a rota resolve o parâmetro `:slug`, antes de
// qualquer chamada à API acontecer.
export const setTenantSlug = (slug) => {
  const trimmed = typeof slug === 'string' ? slug.trim() : '';
  currentTenantSlug = trimmed || DEFAULT_TENANT_SLUG;
};

export const getTenantSlug = () => currentTenantSlug;
